// extracted by mini-css-extract-plugin
export default {"checkbox":"SimpleCheckbox_checkbox__-qp25"};